import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

import OrderBasket from './OrderBasket';

const GetUserInfoQuery = gql`
  query OrderBasketUserQuery {
    userInfo {
      id
      email
      phone
      companyName
      companyRegistrationNumber
      companyVatNumber
      invoiceFirstName
      invoiceLastName
      invoiceStreet
      invoiceHouseNumber
      invoiceZip
      invoiceCity
      invoiceCountry

      saleTaxCertificate
    }
  }
`;

const CreateOrderMutation = gql`
  mutation createOrder($order: OrderInput!) {
    createOrder(order: $order) {
      order {
        id
        orderNumber
        email
        createdAt

        subTotal
        total
        paymentTotal
        deliveryTotal
        grandTotal

        orderedItems {
          id

          title
          name
          description
          definition
          price
          deliveryPriceAddition

          weight
          VATrate
          quantity
          ean
          sku
        }
      }
      maxAvailableStock {
        productVariantId
        inStock
      }
    }
  }
`;

const CreatePaymentMutation = gql`
  mutation createPayment($orderNumber: String!, $language: String!) {
    createPayment(payment: { orderNumber: $orderNumber, language: $language }) {
      gatewayUrl
      error
      token
    }
  }
`;

interface IInputProps {
  children?: any;
}

interface IResponse {
  data: any;
}

export default compose(
  graphql<IInputProps, IResponse>(GetUserInfoQuery, { options: { fetchPolicy: 'cache-and-network' } }),
  graphql<any, any>(CreateOrderMutation, {
    name: 'createOrder'
  }),
  graphql<any, any>(CreatePaymentMutation, {
    name: 'createPayment'
  })
)(OrderBasket);



// WEBPACK FOOTER //
// ./src/pages/OrderBasket/index.tsx